import script from "./DroWer.vue?vue&type=script&setup=true&lang=js"
export * from "./DroWer.vue?vue&type=script&setup=true&lang=js"

import "./DroWer.vue?vue&type=style&index=0&id=4dbefb05&lang=css"

const __exports__ = script;

export default __exports__